var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default",[_vm._v("\n    "+_vm._s(_vm.dictText)+"\n  ")],{"text":_vm.dictText})],2)}
var staticRenderFns = []

export { render, staticRenderFns }